import React from 'react';
import CheckboxField from './index';
import { useField } from 'formik';

import './index.sass';

const FormikCheckboxField = ({ Checkbox = CheckboxField, className, name, ...rest }) => {
    const [field, meta] = useField({ name, type: 'checkbox' });

    return <Checkbox
        {...field}
        className={className}
        error={meta.error}
        {...rest}
    />
}

export default FormikCheckboxField;
